import { Controller } from "@hotwired/stimulus";

const MAX_APP_NAME_LENGTH = 12;
const MIN_ICON_SIZE = 512;
const MAX_ICON_SIZE = 2048;
const MAX_FILE_SIZE = 5 * 1024 * 1024;

export default class extends Controller {
  static targets = ["previewContainer", "squarePreview", "circlePreview", "appName"];

  updatePreviews(event) {
    const fileInput = event.target;
    const file = fileInput.files[0];

    const reader = new FileReader();

    reader.onload = (e) => {
      const img = new Image();

      img.onload = () => {
        const width = img.width;
        const height = img.height;

        if (file.size > MAX_FILE_SIZE) {
          alert("Please select an image that is less than 5MB in size.");
          fileInput.value = "";
          return;
        }

        if (width !== height) {
          alert(
            "Please select a square image for your app icon (width must equal height exactly)."
          );
          fileInput.value = "";
          return;
        }

        if (width < MIN_ICON_SIZE || height < MIN_ICON_SIZE) {
          alert(`Please select an image that is at least ${MIN_ICON_SIZE}px × ${MIN_ICON_SIZE}px.`);
          fileInput.value = "";
          return;
        }

        if (width > MAX_ICON_SIZE || height > MAX_ICON_SIZE) {
          alert(
            `Please select an image that is no larger than ${MAX_ICON_SIZE}px × ${MAX_ICON_SIZE}px.`
          );
          fileInput.value = "";
          return;
        }

        // The image is valid - update the preview
        this.previewContainerTarget.classList.remove("hidden");
        this.squarePreviewTarget.src = e.target.result;
        this.circlePreviewTarget.src = e.target.result;
      };

      img.src = e.target.result;
    };

    reader.readAsDataURL(file);
  }

  updateAppName(event) {
    const appName = event.target.value;
    const displayName =
      appName.length > MAX_APP_NAME_LENGTH
        ? appName.substring(0, MAX_APP_NAME_LENGTH) + "…"
        : appName;

    this.appNameTargets.forEach((element) => {
      element.textContent = displayName;
    });
  }
}
